import {
  ModernPaginationProps,
  Table,
  TableProps,
} from '@moneyforward/ap-frontend-components';
import type { InvoiceTransactionDetail } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo, ReactNode, useMemo } from 'react';
import styles from './Table.module.scss';
const cx = classnames.bind(styles);

export type InternalTableProps = Omit<
  TableProps<InvoiceTransactionDetail & { id: string }>,
  'pagination' | 'emptyType'
>;

export type Props = {
  table: InternalTableProps;
  isSearchEmpty?: boolean;
  pagination: ModernPaginationProps;
  /** Action placed below the table (e.g. 「残りをすべて表示」). */
  footer?: ReactNode;
};

export const TransactionsDetailTable: FC<Props> = memo(
  ({ table, pagination, footer }) => {
    const scroll = useMemo(() => {
      return { x: 'max-content' };
    }, []);

    return (
      <div
        className={cx(styles['container'])}
        data-testid='transactions-detail-table'
      >
        <Table
          emptyType='object'
          {...table}
          legacy={false}
          testId='transactions-detail-table'
          scroll={scroll}
          pagination={pagination}
          rowKey='id'
          bordered
          hideFooterPagination
        />
        {footer && <div className={cx(styles['footer'])}>{footer}</div>}
      </div>
    );
  }
);
TransactionsDetailTable.displayName = 'TransactionsDetailTable';
